import { fetchAllStorageObjects } from "../../../../../app/state/storageObjectSlice/actions/actions";
import { StorageScope } from "../../../../../services/api/instances/storageApi/types/service_types";
import { useAppDispatch } from "../../../../../services/redux/hooks/use-dispatch";

export const useRefreshDataButton = (service: StorageScope) => {
  const dispatch = useAppDispatch();
  const handleRefreshData = () => {
    dispatch(
      fetchAllStorageObjects({
        service,
        ignoreCondition: true,
        withRefresh: true,
      }),
    );
  };
  return { handleRefreshData };
};
